import * as Turbo from "@hotwired/turbo"


document.addEventListener("DOMContentLoaded", function() {
  let signedStreamName = document.querySelector('meta[name="turbo-cable-stream-source"]')?.getAttribute('content');

  if (!signedStreamName) {
    const streamSourceElement = document.querySelector('turbo-cable-stream-source');
    if (streamSourceElement) {
      signedStreamName = streamSourceElement.getAttribute('signed-stream-name');
    }
  }

  if (!signedStreamName) {
    console.warn("No signed stream name found. Make sure your view includes a meta tag with name='turbo-cable-stream-source'");
    return;
  }

  if (window.App && window.App.cable) {
    const streamSubscription = App.cable.subscriptions.create(
      {
        channel: "Turbo::StreamsChannel",
        signed_stream_name: signedStreamName
      },
      {
        connected() {
          const container = document.getElementById('test-messages-container');
          if (container) {
            const div = document.createElement('div');
            div.style.background = '#e6ffe6';
            div.style.padding = '10px';
            div.style.margin = '5px';
            div.textContent = '✅ Connected to authorized stream';
            container.appendChild(div);
          }
        },
        disconnected() {
        },
        received(data) {
          if (typeof data === 'string' && data.includes('turbo-stream')) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data;

            // Find and process turbo-stream elements
            const streamElements = tempDiv.querySelectorAll('turbo-stream');
            if (streamElements.length > 0) {
              streamElements.forEach(element => {
                // Clone and add to the document
                const clone = element.cloneNode(true);
                document.body.appendChild(clone);
              });
            }
          }
        }
      }
    );
    window.streamSubscription = streamSubscription;
  }
});
